// Client version (use mayor and minor, let patch free for teamcity)
export const version = '2.6';

export interface Configuration {
	version: string;
	production: boolean;
	url: string;
	onBootstrapAppInit?: () => Promise<void>;
}
